/* eslint-disable camelcase, @typescript-eslint/naming-convention */
import React, { useState } from 'react';
import { Text } from '@ui/atoms/Text/Text';
import { Button } from '@ui/atoms/Button/Button';
import './AdvancedSectionStyles.scss';
const baseClass = 'qmb-ui-advanced-section';
export function AdvancedSection({ children, defaultExpanded = false }) {
    const [isExpanded, setIsExpanded] = useState(defaultExpanded);
    return (React.createElement("div", { className: baseClass },
        React.createElement(Button, { onClick: () => setIsExpanded(!isExpanded), "aria-expanded": isExpanded },
            React.createElement("i", { className: `fa-light ${isExpanded ? 'fa-chevron-down' : 'fa-chevron-right'}`, "aria-hidden": "true" }),
            React.createElement(Text, { variant: "x-small" }, "Show advanced options")),
        isExpanded && React.createElement("div", { className: `${baseClass}__content` }, children)));
}
